import { render, staticRenderFns } from "./RegionHeader.vue?vue&type=template&id=5bcf79ef&"
import script from "./RegionHeader.vue?vue&type=script&lang=js&"
export * from "./RegionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports